<template>
  <div class="ibox">
    <a class="ibox-results-collapse visible-xs" role="button" data-toggle="collapse" href=".ibox-results-filters-collapse-box" aria-expanded="false" aria-controls="ibox-results-filters-collapse-box">
      Show Filters <i class="fa fa-bars"></i>
    </a>
    <div class="ibox-results-filters-collapse-box collapse in">
      <div class="ibox-results-filters">
        <div class="row">
          <div class="col-sm-6 col-lg-4">
            <div class="form-group">
              <label class="control-label">Name</label>
              <input type="text" class="form-control" placeholder="" @input="updateName" />
            </div>
          </div>
          <div class="col-sm-6 col-lg-4">
            <div class="form-group">
              <label class="control-label">Mobile</label>
              <input type="text" class="form-control" placeholder="" @input="updateMobile" />
            </div>
          </div>
          <div class="col-sm-6 col-lg-4">
            <div class="form-group">
              <label class="control-label">Email</label>
              <input type="text" class="form-control" placeholder="" @input="updateEmail"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ibox-content">
      <ul class="list-detail list-detail-driver">
        <li v-for="driver in drivers" :key="driver.id">
          <div class="driver-item">
            <router-link :to="{ name: 'drivers.edit', params: { id: driver.id }}" class="driver-profile" v-if="driver.thumbnail_url">
              <img v-if="driver.thumbnail_url" :src="driver.thumbnail_url" alt="Driver Name" />
              <img v-else src="" alt="Driver Name" />
            </router-link>
            <div class="row">
              <div class="col-md-5 col-lg-4">
                <h2 class="truncate"><router-link :to="{ name: 'drivers.edit', params: { id: driver.id }}">{{ driver.profile.full_name }}</router-link><strong></strong></h2>
              </div>
              <div class="col-md-3">
                <p class="truncate" v-if="driver.mobile">
                  <i class="fa fa-phone"></i>
                  <a :href="`tel:${driver.mobile}`">{{ driver.mobile }}</a>
                </p>
              </div>
              <div class="col-md-5">
                <p class="truncate" v-if="driver.email">
                  <i class="fa fa-at"></i>
                  <a :href="`mailto:${driver.email}`">{{ driver.email }}</a>
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="text-center text-muted" v-show="haveNoDrivers">
        <strong>There are no drivers.</strong>
      </div>
    </div>

    <lazy-loading v-show="haveDrivers" :reached-bottom="getDriversForNextPage" :filters="filters" ref="lazyLoading">
      <strong slot="finished" class="text-muted">There are no more drivers.</strong>
    </lazy-loading>
  </div>
</template>

<script>
  import { LazyLoading } from 'components/misc'
  import { Selectize } from 'components/forms'
  import { debounce, isEqual, clone } from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import { Roles } from 'utils/user'

  export default {
    components: {
      Selectize,
      LazyLoading
    },

    data () {
      return {
        initialUserOptions: [],
        name: '',
        mobile: '',
        email: '',
        status: 1,
        user: null
      }
    },

    watch: {
      filters: {
        handler (newFilters, oldFilters) {
          if (isEqual(newFilters, oldFilters)) {
            return
          }

          // Reset the lazy loading component so that it will attempt to load
          // more jobs as we scroll again.
          const resetLazyLoading = () => (this.$refs.lazyLoading.$emit('reset'))

          this.getDrivers(this.filters).then(resetLazyLoading)
        },
        deep: true
      }
    },

    created () {
      if (this.$route.query.user) {
        this.user = this.$route.query.user
      }

      this.getDrivers(this.filters)

      const setInitialUserOptions = () => (this.initialUserOptions = clone(this.userOptionsWithAll))

      if (this.$user.isAdminOrCoordinator) {
        if (this.$route.query.user) {
          this.user = this.$route.query.user
        }

        this.getUsers({ master: true, roles: [Roles.ADMIN, Roles.COORDINATOR, Roles.CARRIER] }).then(setInitialUserOptions)
      }
    },

    computed: {
      ...mapGetters('driver', { drivers: 'driversDecorated' }),
      ...mapGetters('user', ['userOptionsWithAll']),

      /**
       * Computed filters to track changes.
       *
       * @return object
       */
      filters () {
        return {
          name: this.name,
          mobile: this.mobile,
          email: this.email,
          user_id: this.user
        }
      },

      /**
       * Determine if we have no drivers.
       *
       * @return boolean
       */
      haveNoDrivers () {
        return this.drivers.length === 0
      },

      /**
       * Determine if we have drivers.
       *
       * @return boolean
       */
      haveDrivers () {
        return this.drivers.length > 0
      }
    },

    methods: {
      ...mapActions('driver', ['getDrivers', 'getDriversForNextPage']),
      ...mapActions('user', ['getUsers']),

      /**
       * When admin types in the user select box we need to fetch more users
       * from the api since the users are paginated.
       */
      fetchUserResults (name, callback) {
        return this.getUsers({ name, master: true, roles: [Roles.ADMIN, Roles.COORDINATOR, Roles.CARRIER] }).then(response => {
          callback(this.userOptionsWithAll)
        })
      },

      /**
       * Debounce updating of keywords so we don't poll API immediately for new drivers.
       *
       * @param object event
       *
       * @return Function
       */
      updateName: debounce(function (event) {
        this.name = event.target.value
      }, 800),

      /**
       * Debounce updating of mobile so we don't poll API immediately for new drivers.
       *
       * @param object event
       *
       * @return Function
       */
      updateMobile: debounce(function (event) {
        this.mobile = event.target.value
      }, 800),

      /**
       * Debounce updating of email so we don't poll API immediately for new drivers.
       *
       * @param object event
       *
       * @return Function
       */
      updateEmail: debounce(function (event) {
        this.email = event.target.value
      }, 800)
    }
  }
</script>



// WEBPACK FOOTER //
// Drivers.vue?f6a3af4c